import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { registerCustomizationType, registerExtensionType } from '@celum/core/extensions';

import { CelumList } from './components/celum-list/celum-list';
import { CelumDynamicListItem } from './components/dynamic-list-item';
import { CelumSimpleList } from './components/simple-list/simple-list';
import { CelumVirtualList } from './components/virtual-list/virtual-list';
import { OneCardItemCustomization } from './extension-point/card-item-customization';
import { CardItemExtension } from './extension-point/card-item-extension';

/**
 * ⚠ Requires dependencies `ngx-infinite-scroll` and `ng2-dragula`.
 */
@NgModule({
  imports: [CelumList, CelumSimpleList, CelumDynamicListItem, CelumVirtualList, TranslatePipe],
  exports: [CelumList, CelumSimpleList, CelumVirtualList, CelumDynamicListItem, TranslatePipe]
})
export class CelumListModule {
  constructor() {
    registerExtensionType(CardItemExtension, CardItemExtension.type);
    registerCustomizationType(OneCardItemCustomization, OneCardItemCustomization.type);
  }
}
